import React from 'react'
import QuestionCell from './QuestionCell'
import { IdentityQuestionItem } from '../../../service/api/knowledge'

interface QuestionListProps {
    dataSource?: IdentityQuestionItem[]
    onItemClick?: (item: IdentityQuestionItem) => void
}
const QuestionList: React.FC<QuestionListProps> = (props) => {
    const { dataSource = [], onItemClick = () => undefined } = props
    return (
        <div>
            {dataSource.map((item) => (
                <QuestionCell
                    key={item.questionId}
                    title={item.userQuestion}
                    onClick={() => {
                        onItemClick(item)
                    }}
                />
            ))}
        </div>
    )
}

export default QuestionList
